import { useRef, useEffect, Fragment } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import useLineLiff from 'hooks/LineLiff';
import { sendLineReurlTag } from './utils/LinePostbackActions';

const LexusReurlPage = () => {
  const hasSentRequest = useRef(false);

  const { reurlType } = useParams();
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirectUrl');
  const signature = searchParams.get('signature');
  const tags = searchParams.getAll('tag');
  const liffState = searchParams.get('liff.state');

  const { liff, userInfo } = useLineLiff(process.env.REACT_APP_LIFF_ID_REURL);

  useEffect(() => {
    if (liffState || !userInfo || hasSentRequest.current) return;

    const idToken = liff.getIDToken();
    hasSentRequest.current = true;

    const processReurl = async () => {
      let returnUserId = '';

      try {
        if (tags.length === 0) return;
        const result = await sendLineReurlTag(
          {
            type: reurlType,
            tags,
            signature,
          },
          idToken
        );
        if (result.success) {
          returnUserId = result.data.rud;
        }
      } catch (error) {
        console.error('Error sending reurl tag:', error);
      } finally {
        let finalUrl;
        if (redirectUrl) {
          finalUrl = atob(redirectUrl);
        } else {
          finalUrl =
            process.env.REACT_APP_LEXUS_LINE_URL || 'https://www.lexus.com.tw/';
        }
        // Special handling for social media links
        if (
          finalUrl.includes('facebook') ||
          finalUrl.includes('instagram') ||
          finalUrl.includes('youtu')
        ) {
          liff.openWindow({
            url: finalUrl,
            external: true,
          });
          liff.closeWindow();
        } else {
          const url = new URL(finalUrl, window.location.origin);
          url.searchParams.append('rud', returnUserId);
          window.location.href = url.toString();
        }
      }
    };

    processReurl();
    // window.location.href = redirectUrl
  }, [liff, userInfo, liffState, reurlType, redirectUrl, signature, tags]);

  return <Fragment />;
};

export default LexusReurlPage;
